export const getApiBase = (): string => {
  const explicit = (
    typeof process !== 'undefined' && process.env
      ? process.env.REACT_APP_API_BASE || ''
      : ''
  ).trim();
  if (explicit) return explicit.replace(/\/+$/, '');

  const { hostname, port, protocol, origin } = window.location;

  // 로컬 개발 서버(3000/5173 등)에서는 같은 호스트의 8000 백엔드 사용
  // => CRA proxy를 쓰기 위해 빈 문자열 반환 (/api 로 호출)
  if (port === '3000' || port === '5173') {
    return '';
  }

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'http://localhost:8000';
  }

  // https 페이지에서 http API를 직접 호출하면 mixed-content로 막히므로 same-origin 우선
  if (protocol === 'https:') {
    return origin;
  }

  // 운영/배포 환경에서는 동일 origin 프록시(/api) 우선
  return `http://${hostname}:8000`;
};

export const normalizeFetchError = (err: any, apiBase: string, fallback: string): string => {
  const raw = String(err?.message || '').trim();
  const lower = raw.toLowerCase();
  const isNetwork =
    lower.includes('load failed') ||
    lower.includes('failed to fetch') ||
    lower.includes('networkerror') ||
    lower.includes('network request failed');

  if (isNetwork) {
    const target = apiBase || 'same-origin proxy(/api)';
    return `${fallback} (네트워크 연결 실패: API ${target})`;
  }
  return raw || fallback;
};
